import { render, staticRenderFns } from "./modalUser.vue?vue&type=template&id=d053afd0"
import script from "./modalUser.vue?vue&type=script&lang=js"
export * from "./modalUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports